import { useGameStore } from '../store/gameStore';
import { Button } from '@/components/ui/button';
import { Trash2, Clock, SkipForward, Users } from 'lucide-react';

interface Props {
  onUse: (type: string) => void;
}

export const Lifelines = ({ onUse }: Props) => {
  const { usedLifelines } = useGameStore();

  const lifelines = [
    { 
      id: 'removeTwoOptions', 
      label: 'حذف خيارين', 
      icon: Trash2,
      description: 'حذف خيارين خاطئين',
      color: 'text-red-600'
    },
    { 
      id: 'extraTime', 
      label: 'وقت إضافي', 
      icon: Clock,
      description: '+30 ثانية',
      color: 'text-blue-600'
    },
    { 
      id: 'skipQuestion', 
      label: 'تخطي', 
      icon: SkipForward,
      description: 'تخطي السؤال',
      color: 'text-green-600'
    },
    { 
      id: 'askAudience', 
      label: 'سؤال الجمهور', 
      icon: Users,
      description: 'مساعدة الجمهور',
      color: 'text-purple-600'
    },
  ];

  return (
    <div className="flex flex-wrap gap-2">
      {lifelines.map((lifeline) => {
        const isUsed = usedLifelines.includes(lifeline.id);
        const Icon = lifeline.icon;
        return (
          <Button
            key={lifeline.id}
            variant="outline"
            size="sm"
            onClick={() => !isUsed && onUse(lifeline.id)}
            disabled={isUsed}
            className={`gap-2 border-2 ${
              isUsed 
                ? 'opacity-50 cursor-not-allowed border-gray-300' 
                : `hover:border-${lifeline.color.split('-')[1]}-600 border-gray-300`
            }`}
            title={lifeline.description}
          >
            <Icon className={`w-4 h-4 ${isUsed ? 'text-gray-400' : lifeline.color}`} />
            <span className={isUsed ? 'text-gray-400' : 'text-gray-700'}>{lifeline.label}</span>
          </Button>
        );
      })}
    </div>
  );
};
